'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateScreen = undefined;

var _validateProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty');

var validateScreen = exports.validateScreen = function validateScreen(screen) {
  var isValidScreen = typeof screen === 'string' && screen.length > 0;

  return (0, _validateProperty.validateProperty)(isValidScreen, 'expected screen to be a non-empty string but got ' + screen, 'screen');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/validators/validateScreen.js
// module id = 442
// module chunks = 3 4 5